module.exports = __webpack_public_path__ + "static/media/icon-share.ba3f354d.png";